import INTEGRATION_MENTIONS from './IntegrationMentions';
import type {
  ExternalSearchPlatformInfo,
  IntegrationPlatformInfo,
} from './IntegrationPlatformInfo';
import {
  INSTALLABLE_PLATFORM_INFO_MAP,
  SEARCH_PLATFORM_INFO_MAP,
} from './IntegrationPlatformInfo';

const getPlatformInfoFromMentionType = (
  type: string,
): Partial<ExternalSearchPlatformInfo | IntegrationPlatformInfo> => {
  const mentionInfo =
    INTEGRATION_MENTIONS[type as keyof typeof INTEGRATION_MENTIONS] || {};
  const mentionInfoPlatform =
    'platform' in mentionInfo ? (mentionInfo.platform as string) : null;

  const platform =
    mentionInfoPlatform ?? (type.toLowerCase().split('_')[0] as string);

  const info =
    SEARCH_PLATFORM_INFO_MAP[platform] ??
    INSTALLABLE_PLATFORM_INFO_MAP[platform];

  const mentionInfoIcon =
    'icon' in mentionInfo
      ? (mentionInfo.icon as IntegrationPlatformInfo['icon'])
      : null;

  return {
    ...info,
    icon: mentionInfoIcon ?? info?.icon,
  };
};

export default getPlatformInfoFromMentionType;
